import React, {useState} from "react";

import tip1 from "../assets/images/tip1.svg";
import tip2 from "../assets/images/tip2.svg";
import tip3 from "../assets/images/tip3.svg";

import useOnInteractionModalStore from "./onInteractionModal/useOnInteractionModalStore";

const OnBoardingInstructionsMobile = () => {
  const {showContent: setContent} = useOnInteractionModalStore();

  const [state, setState] = useState(1);

  type TipConfig = {
    btn: {
      msg: string;
      bgColor: string;
      onClick: () => void;
    };
    img: {
      mb: number;
      src: string;
      flexAlign: string;
    };
  };

  type State2TipConfig = {
    [key in number]: TipConfig;
  };

  const tipsConfig: State2TipConfig = {
    [1]: {
      btn: {
        msg: "Siguiente",
        bgColor: "tips-gray",
        onClick: () => setState((s) => s + 1),
      },
      img: {
        mb: 64,
        src: tip1,
        flexAlign: "",
      },
    },
    [2]: {
      btn: {
        msg: "Siguiente",
        bgColor: "tips-gray",
        onClick: () => setState((s) => s + 1),
      },
      img: {
        mb: 32,
        src: tip2,
        flexAlign: "items-end",
      },
    },
    [3]: {
      btn: {
        msg: "Comenzar",
        bgColor: "torre-pink",
        onClick: () => setContent(null),
      },
      img: {
        mb: 64,
        src: tip3,
        flexAlign: "",
      },
    },
  };

  return (
    <>
      <div className="absolute z-10 bottom-0 left-0 text-white">
        <button
          className={`uppercase bg-${tipsConfig[state].btn.bgColor} text-xl mb-8 ml-8 px-4 py-2`}
          onClick={tipsConfig[state].btn.onClick}
        >
          {tipsConfig[state].btn.msg}
          {" >"}
        </button>
      </div>
      <div
        className={`flex justify-center w-screen h-screen ${tipsConfig[state].img.flexAlign}`}
      >
        <img
          className={`mb-${tipsConfig[state].img.mb} w-64`}
          src={tipsConfig[state].img.src}
          alt="tip"
        />
      </div>
    </>
  );
};

export default OnBoardingInstructionsMobile;
